import { render, staticRenderFns } from "./CourseRemovalForm.vue?vue&type=template&id=5ec7cc80&scoped=true&"
import script from "./CourseRemovalForm.vue?vue&type=script&lang=js&"
export * from "./CourseRemovalForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseRemovalForm.vue?vue&type=style&index=0&id=5ec7cc80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec7cc80",
  null
  
)

export default component.exports